import React from 'react';
import { Link } from 'react-router-dom';

const Blog = () => {
  const posts = [
    {
      id: 'mosquito-tracking',
      title: 'Revolutionizing Vector Control with VectorScope',
      excerpt: 'How our app transforms vector-borne disease surveillance in Kenya.',
      date: '2025-08-15',
    },
    {
      id: 'digital-health',
      title: 'The Future of Digital Health in Kenya',
      excerpt: 'AI and cloud in healthcare solutions.',
      date: '2025-07-10',
    },
    {
      id: 'sormas-dengue',
      title: 'Combating Dengue with SORMAS',
      excerpt: 'Customized tool for outbreak detection.',
      date: '2025-06-20',
    },
  ];

  return (
    <section id="blog" className="py-20 bg-gray-100">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-12 text-blue-800">Our Blog</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map((post) => (
            <div key={post.id} className="border rounded-xl p-6 shadow-md bg-white hover:shadow-lg transition-all">
              <h3 className="text-xl font-semibold mb-2 text-teal-600">{post.title}</h3>
              <p className="text-gray-600 mb-2">{post.excerpt}</p>
              <p className="text-gray-500 text-sm mb-4">{post.date}</p>
              <Link to={`/blog/${post.id}`} className="text-teal-500 hover:underline font-semibold">
                Read More
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;